/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Route definitions
 * @author Dustin Gage
 * @module epic-px\C:\EpicSource\git\PIRATES\ochins-eleven\src\routes.ts
 */

import { lazy, LazyExoticComponent } from "react";

interface ILazyRoute {
	/** page "slug" that should not start or end with a slash */
	path: string;
	/**
	 * Component that is a result of a promise
	 * Use dynamic import to specify component to render
	 */
	component: LazyExoticComponent<any>;
}

const routes: ILazyRoute[] = [
	{
		path: "triage",
		component: lazy(async () => {
			await import(/*webpackChunkName: "zip-to-coords" */ "./api/zips-to-coordinates");
			return import(/*webpackChunkName: "triage" */ "./components/pages/Triage");
		}),
	},
	{
		path: "scheduling",
		component: lazy(async () => {
			return import(/*webpackChunkName: "scheduling" */ "./components/pages/Schedule");
		}),
	},
	{
		path: "schedule",
		component: lazy(async () => {
			return import(/*webpackChunkName: "schedule" */ "./components/pages/AccessCode");
		}),
	},
];

export { routes };
